module.exports = __webpack_public_path__ + "img/img_bed_app_2_ko.027ecca4.png";